// extracted by mini-css-extract-plugin
export default {"bankField":"BankAccountDetails_bankField__b9+z0"};